import { Breadcrumb, Col, Modal, notification, Row, Spin, Tabs, Button } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';
import productAPI from '~/api/ProductAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import CancelModal from '~/components/FormCancel';
import config from '~/config';
import { addProductToCartStore } from '~/store/actions/CartProductAction';
import { getNumberWithCommas } from '~/utils';
import styles from './ProductDetail.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useSelector } from 'react-redux';
import FormCanNot from '~/components/FormCanNot';
import FormShare from '~/components/FormShare';
import shareAPI from '~/api/Share';
import { ShareAltOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);
const { TabPane } = Tabs;
const SlideImage = styled.div`
    .SpaDetail_content_service__GKDMf .SpaDetail_image-container__Mk12S {
        width: 100% !important;
        // width: 5000px;
    }
    ul {
        bottom: -110px;
        height: 100px;
        width: auto;
    }
    .slick-dots li {
        width: 15%;
        height: 100px;
    }
    img {
        vertical-align: top;
        width: 100%;
    }
`;

const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 20px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;

const ProductDetail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const userInfo = useSelector((state) => state.user.userInfo);

    const [isLoading, setIsLoading] = useState(false);

    const isLogin = userInfo?.id || '';

    const { product_id } = useParams();
    const [productInfo, setProductInfo] = useState({});

    const [count, setCount] = useState(1);

    const [activeKey, setActiveKey] = useState('1');
    const onChangeTabs = (key) => {
        setActiveKey(key);
        console.log(key);
    };

    const settings = {
        customPaging: function (index) {
            return <img src={productInfo?.image[index]} alt="" />;
        },
        dots: true,
        dotsClass: 'slick-dots slick-thumb',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);
    const [linkShare, setLinkShare] = useState('');

    const onAgreeLogin = () => {
        navigate(config.routes.login);
        localStorage.setItem('navigateAfterLogin', location.pathname + location.search);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    const handleGetOneProductInfo = async () => {
        setIsLoading(true);
        try {
            let product = {};
            const params = {
                fields: '["$all"]',
            };
            const res = await productAPI.getOneProductAPI(product_id, params);
            if (res.code === 200) {
                product = { ...res.results.object };
            }
            const search = location?.search?.split('?').join('');
            const sharerId = new URLSearchParams(search)?.get('sharer_id');
            if (sharerId && sharerId !== userInfo?.id) {
                product.sale_price = (product.price * 5) / 100;
                product.sharer_id = sharerId;
            } else {
                product.sale_price = 0;
                product.sharer_id = '';
            }
            setProductInfo(product);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    const handleAddProductToCart = () => {
        if (productInfo?.inventory_amount_branch) {
            productInfo.amount = count;
            productInfo.deducted_price = productInfo.price - productInfo.sale_price;
            productInfo.total_price = productInfo.deducted_price * count;
            productInfo.sharer_id = productInfo.sharer_id || '';
            dispatch(addProductToCartStore(productInfo));
            notification.open({
                message: 'Product added to cart',
                duration: 2,
                placement: 'top',
            });
        }

        // if (isLogin) {
        //     if (productInfo?.inventory_amount_branch) {
        //         productInfo.amount = count;
        //         productInfo.deducted_price = productInfo.price - productInfo.sale_price;
        //         productInfo.total_price = productInfo.deducted_price * count;
        //         productInfo.sharer_id = productInfo.sharer_id || '';
        //         dispatch(addProductToCartStore(productInfo));
        //         notification.open({
        // message: 'Product added to cart',
        //             duration: 2,
        //             placement: 'top',
        //         });
        //     }
        // } else {
        //     localStorage.setItem(
        //         'navigateAfterLogin',
        //         `/thong-tin-san-pham/${productInfo?.id}?sharer_id=${productInfo.sharer_id}`,
        //     );
        //     setIsShowRequireLogin(true);
        // }
    };

    const [isShowCanNotShare, setIsShowCanNotShare] = useState(false);

    const [isShowShare, setIsShowShare] = useState(false);
    const [titleShare, setTitleShare] = useState('');
    const [contentShare, setContentShare] = useState('');

    const handleAgreeShare = async () => {
        handleShare();
        onCopy();
        setIsShowShare(false);
    };
    const handleRejectShare = () => {
        setIsShowShare(false);
    };
    const handleShare = () => {
        if (navigator.share) {
            navigator
                .share({
                    title: 'Ahappi - Ecommerce\n',
                    text: productInfo?.title,
                    url: linkShare,
                })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        }
    };

    const onCopy = async () => {
        notification.open({
            message: 'Copy link successfully!',
            duration: 2,
            placement: 'top',
        });
        await navigator.clipboard.writeText(linkShare);
    };

    const handleClickShare = async () => {
        if (isLogin) {
            if (userInfo?.is_can_share_product) {
                try {
                    const res = await shareAPI.createLinkShareAPI({ product_id: productInfo?.id });
                    setLinkShare(res?.results?.object?.link);
                } catch (err) {
                    console.log(err);
                }
                setTitleShare(`Share product ${productInfo?.title}`);
                setContentShare(
                    `The commission amount you receive after generating a transaction is ${getNumberWithCommas(
                        (productInfo?.price * 2) / 100 || 0,
                    )} d`,
                );
                setIsShowShare(true);
            } else {
                setIsShowCanNotShare(true);
            }
        } else {
            setIsShowRequireLogin(true);
        }
    };

    useEffect(() => {
        handleGetOneProductInfo();

        //eslint-disable-next-line
    }, [product_id]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinSanPham');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div>
                <Breadcrumb className={cx('breadcrumb')}>
                    <Breadcrumb.Item>Product</Breadcrumb.Item>
                    <Breadcrumb.Item className={cx('breadcrumItemActive')}>Product Information</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {productInfo?.id ? (
                        <>
                            <div className={cx('content_product')}>
                                <Row className={cx('content_product_row')}>
                                    <Col xs={24} sm={12} md={12} style={{ padding: '0px 7px' }}>
                                        {productInfo.image?.length ? (
                                            <SlideImage>
                                                <Slider {...settings}>
                                                    {productInfo.image?.map((item, index) => {
                                                        return (
                                                            <div
                                                                className={cx('image-container')}
                                                                key={index.toString()}
                                                            // style={{ display: 'flex' }}
                                                            >
                                                                <img src={item} alt="" />
                                                                {productInfo?.inventory_amount_branch > 0 ? null : (
                                                                    <div className={cx('no_product')}>Sold out</div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>
                                            </SlideImage>
                                        ) : (
                                            <>
                                                <img
                                                    className={cx('image_main')}
                                                    src={productInfo?.thumbnail || IMAGES.NewLogoCut}
                                                    alt=""
                                                />
                                                {productInfo?.inventory_amount_branch > 0 ? null : (
                                                    <div className={cx('no_product')}>Sold out</div>
                                                )}
                                                {/* <div className={cx('no_product')}>Sold out</div> */}
                                            </>
                                        )}
                                    </Col>
                                    <Col
                                        className={cx(
                                            productInfo?.image?.length ? 'product_detail' : 'product_detail_no_slide',
                                        )}
                                        xs={24}
                                        sm={12}
                                        md={12}
                                    >
                                        {parseInt(productInfo?.sale_price) ? (
                                            <>
                                                <Row className={cx('sale_off')}>
                                                    Sale{' '}
                                                    {Math.round((productInfo?.sale_price * 100) / productInfo?.price)}%
                                                </Row>
                                            </>
                                        ) : null}

                                        <Row className={cx('name')}>{productInfo?.title}</Row>
                                        <Row className={cx('amount_sale')}>
                                            <Row>Sold: {productInfo?.amount_sale} product</Row>
                                        </Row>

                                        <Row align="middle" className={cx('price')}>
                                            <Col xs={16}>
                                                {parseInt(productInfo?.sale_price) ? (
                                                    <>
                                                        <span className={cx('price_sale')}>
                                                            {getNumberWithCommas(
                                                                productInfo?.price - productInfo?.sale_price,
                                                            )}{' '}
                                                            d
                                                        </span>
                                                        <span className={cx('price_origin')}>
                                                            {getNumberWithCommas(productInfo?.price)} d
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span className={cx('price_sale')}>
                                                        {getNumberWithCommas(productInfo?.price)} d
                                                    </span>
                                                )}
                                            </Col>
                                            <Col xs={8}>
                                                <Row justify="end">
                                                    <div className={cx('btn_share')} onClick={handleClickShare}>
                                                        Share
                                                        <ShareAltOutlined
                                                            style={{
                                                                fontSize: '20px',
                                                                fontWeight: '600',
                                                                color: '#311d4f',
                                                            }}
                                                        />
                                                    </div>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* <img
                                            src={SVGS.IconShare}
                                            alt=""
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleClickShare}
                                        /> */}
                                        {productInfo?.description ? (
                                            <Row justify="center" className={cx('summary')}>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: productInfo?.description }}
                                                ></div>
                                            </Row>
                                        ) : null}

                                        <div className={cx('fontsize_16px')}>Quantity</div>
                                        <Row align="middle" gutter={[30, 30]}>
                                            <Col align="middle">
                                                <Row span={8} className={cx('border')}>
                                                    <div
                                                        className={cx(
                                                            count > 1 ? 'button_count' : 'button_count_disable',
                                                        )}
                                                        onClick={() => {
                                                            setCount(count > 1 ? count - 1 : count);
                                                        }}
                                                    >
                                                        <img src={SVGS.IconSub} alt="" />
                                                    </div>
                                                    <span className={cx('count')}>
                                                        {productInfo?.inventory_amount_branch > 0 ? count : 0}
                                                    </span>
                                                    <div
                                                        className={cx(
                                                            count < productInfo?.inventory_amount_branch
                                                                ? 'button_count'
                                                                : 'button_count_disable',
                                                        )}
                                                        onClick={() => {
                                                            setCount(
                                                                count < productInfo?.inventory_amount_branch
                                                                    ? count + 1
                                                                    : count,
                                                            );
                                                        }}
                                                    >
                                                        <img src={SVGS.IconPlus} alt="" />
                                                    </div>
                                                </Row>
                                            </Col>

                                            <Col>
                                                <div
                                                    className={cx('button')}
                                                    onClick={handleAddProductToCart}
                                                    style={{
                                                        cursor:
                                                            productInfo?.inventory_amount_branch > 0 ? '' : 'no-drop',
                                                    }}
                                                >
                                                    Add to cart
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className={cx(productInfo.image?.length ? 'tabs_content' : 'tabs_content_no_slide')}>
                                {productInfo?.sub_description ? (
                                    <TabsContainer>
                                        <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                            <TabPane tab="More information" key="1">
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: productInfo?.sub_description }}
                                                ></div>
                                            </TabPane>
                                        </Tabs>
                                    </TabsContainer>
                                ) : null}
                            </div>
                        </>
                    ) : (
                        <Row justify="center" className={cx('product_no_exist')}>
                            Product does not exist
                        </Row>
                    )}
                </>
            )}

            {isShowRequireLogin && (
                <Modal
                    centered
                    visible={isShowRequireLogin}
                    onCancel={() => setIsShowRequireLogin(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeLogin}
                            onRejectCancel={onRejectLogin}
                            text="Do you want to log in to continue?"
                        />
                    </div>
                </Modal>
            )}
            {isShowCanNotShare && (
                <Modal
                    centered
                    visible={isShowCanNotShare}
                    onCancel={() => setIsShowCanNotShare(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormCanNot
                            onAgree={() => setIsShowCanNotShare(false)}
                            text="Need to purchase at least 1 product to be able to share this product!"
                            textAlignStart={false}
                            title="Notification"
                            btnBottom={true}
                        />
                    </div>
                </Modal>
            )}
            {isShowShare && (
                <Modal
                    centered
                    visible={isShowShare}
                    onCancel={() => setIsShowShare(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormShare
                            onAgree={handleAgreeShare}
                            onReject={handleRejectShare}
                            title={titleShare}
                            content={contentShare}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default ProductDetail;
